import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { AsyncSelect } from "@/components/ui/v2/async-select";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/v2/form";
import { Input } from "@/components/ui/v2/input";
import {
  FeedFormatOption,
  getFeedFormatOptions,
} from "@/features/clients/feedFormatOptions";
import { AddClientRequest } from "@/types/request/AddClientRequest";

const ClientFeedStep = () => {
  const { t } = useTranslation();
  const { control } = useFormContext<AddClientRequest>();
  const feedFormatOptions = getFeedFormatOptions();

  return (
    <>
      <FormField
        control={control}
        name="feedUrl"
        render={({ field }) => (
          <FormItem>
            <FormLabel>
              {t("admin.client.addClient.clientType.feed.feedUrl")}
            </FormLabel>
            <FormControl>
              <Input
                {...field}
                placeholder={t("admin.client.addClient.clientType.feed.feedUrl")}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={control}
        name="feedFormat"
        render={({ field, fieldState }) => (
          <FormItem>
            <FormLabel>
              {t("admin.client.addClient.clientType.feed.feedFormat")}
            </FormLabel>
            <FormControl>
              <AsyncSelect<FeedFormatOption>
                preload
                fetcher={async () => feedFormatOptions}
                filterFn={(option, query) =>
                  option.label.toLowerCase().includes(query.toLowerCase())
                }
                getOptionValue={(option) => option.value}
                getDisplayValue={(option) => option.label}
                renderOption={(option) => (
                  <span className="truncate">{option.label}</span>
                )}
                value={field.value ?? ""}
                onChange={field.onChange}
                width="100%"
                clearable={false}
                aria-invalid={!!fieldState.error}
                label={t("admin.client.addClient.clientType.feed.feedFormat")}
                placeholder={t(
                  "admin.client.addClient.clientType.feed.feedFormat"
                )}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
};

export default ClientFeedStep;
